/* Roselle: bridge legacy PageFly/Globo success callbacks to Gecko 6 / The4.
 * This never adds, changes or removes cart lines; native sections remain authoritative. */
(function (window, document) {
  'use strict';
  if (window.RoselleCartCompat) return;
  var pending = false, inFlight = false, ownRendering = false, timer = null, watchdog = null;
  var readyAttempts = 0, refreshAttempts = 0;
  function schedule() {
    if (timer !== null || inFlight) return;
    timer = window.setTimeout(run, 80);
  }
  function requestRefresh() {
    pending = true;
    readyAttempts = 0;
    refreshAttempts = 0;
    schedule();
  }
  function warn() {
    if (window.console) window.console.warn('[Roselle cart] Native refresh unavailable; use the cart link.');
  }
  function run() {
    timer = null;
    if (!pending || inFlight) return;
    var theme = window.T4SThemeSP, cart = theme && theme.Cart;
    var pageCart = window.T4Srequest && window.T4Srequest.page_type === 'cart';
    var disabled = window.T4Sconfigs && window.T4Sconfigs.cartType === 'disable';
    var drawer = document.querySelector('#t4s-mini_cart');
    var section = pageCart ? window.cartT4SectionID : 'mini_cart';
    if (!cart || typeof cart.renderContents !== 'function' || typeof theme.getToFetchSection !== 'function' ||
        (pageCart && !section) || (!pageCart && !disabled && (!drawer || !drawer.querySelector('[data-cart-items]')))) {
      if (++readyAttempts < 100) schedule();
      else { pending = false; warn(); }
      return;
    }
    var sections = 'cart_data' + (disabled && !pageCart ? '' : ',' + section);
    pending = false;
    inFlight = true;
    // Native helper returns a promise. Do not overlap an uncancellable slow read.
    watchdog = window.setTimeout(function () { watchdog = null; warn(); }, 10000);
    Promise.resolve().then(function () {
      return theme.getToFetchSection('?sections=' + sections, 'json');
    }).then(function (result) {
      if (!result || typeof result.cart_data !== 'string' ||
          (!disabled && typeof result[section] !== 'string')) throw new Error('Missing cart sections');
      // A newer add finished during this read: discard the old snapshot, then read again.
      if (!pending) {
        ownRendering = true;
        try { cart.renderContents(result, true); }
        finally { ownRendering = false; }
      }
      refreshAttempts = 0;
    }).catch(function () {
      if (++refreshAttempts < 2) pending = true;
      else warn();
    }).finally(function () {
      if (watchdog !== null) window.clearTimeout(watchdog);
      watchdog = null;
      inFlight = false;
      if (pending) schedule();
    });
  }
  document.addEventListener('cart:update:count', function (event) {
    var raw = event.detail && event.detail.count;
    if (raw === undefined || raw === null || String(raw).trim() === '') return;
    var count = Number(raw);
    if (!Number.isFinite(count) || count < 0 || Math.floor(count) !== count) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
      badge.textContent = String(count);
      badge.classList.toggle('t4s-op-0', count === 0);
    });
    var drawer = document.querySelector('#t4s-mini_cart');
    if (drawer) drawer.setAttribute('data-ccount', String(count));
    document.documentElement.classList.toggle('t4s-cart-count-0', count === 0);
    // A native quantity/remove action completed while our snapshot was being read.
    if (inFlight && !ownRendering) pending = true;

  });
  var legacy = window.geckoShopify;
  if (legacy == null) legacy = window.geckoShopify = {};
  if ((typeof legacy === 'object' || typeof legacy === 'function') && typeof legacy.onCartUpdate !== 'function') {
    legacy.onCartUpdate = requestRefresh;
  }
  document.addEventListener('gpoAddedToCart', requestRefresh);
  window.RoselleCartCompat = { version: '20260919.1', refresh: requestRefresh };
})(window, document);
